/*****
 *
 * @TODO:
 * @param sessionStorage
 * @param leadFormService
 * @param localStorage
 */


function similarVehiclesService ($http, $window, $location, sessionStorageService, localStorageService, leadFormService) {
    const DRV_ENDPOINT = '/ajax/listingsapi/1.0/drv',
          DRV_STORAGE_KEY = 'cars.similarVehicle';

    return {
        getDrvListings : getListings,
        shouldShowNoResults: shouldShowNoResults,
        saveSimilarVehicle: saveSimilarVehicle,
        sendAdditionalLead
    };

    function createString (obj, pageName) {
        var s = "?";
        angular.forEach(obj, function (value, key){
            s += "&" + key + "=" + value;
        });
        if ( pageName ) {
            s += "&pageName=" + pageName;
        }
        return s;
    }

    function getListings(args, pageName) {
        return $http.get(
            DRV_ENDPOINT + createString(args, pageName)
        ).then(function (response) {
            return response;
        }).catch(function () {
            return false;
        });
    }

    function shouldShowNoResults() {
        return ( $location.url().indexOf("moveTo=SV") > 0 );
    }

    function saveSimilarVehicle (similarVehicle) {
        sessionStorageService.setItem(DRV_STORAGE_KEY, JSON.stringify(groomListing(similarVehicle)));
    }

    function groomListing (listing) {
        return {
            year: listing.modelYear,
            make: listing.makeName,
            model: listing.modelName,
            trim: listing.trimName
        };
    }

    function sendAdditionalLead (drvListing) {
        let emailFormData = JSON.parse(localStorageService.getItem('Cars.emailFormData'));
        emailFormData.dtfrm = angular.isDefined($window.parm3) ? $window.parm3.utiwhl() : '';

        return leadFormService.submitLead(emailFormData, leadFormService.transformDrvListing(drvListing));
    }
}

similarVehiclesService.$inject = [
    '$http',
    '$window',
    '$location',
    'sessionStorageService',
    'localStorageService',
    'leadFormService'
];

export default similarVehiclesService;
